import css from './Details.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { IGoodServiceTicketData } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

import { ButtonWhiteBlack } from 'components/Actions/Action'
import DataTestId from 'meta/dataTestId'

interface Props {
  data: IGoodServiceTicketData
}

const Details: React.FC<Props> = (props) => {
  const { data } = props

  const { t } = useTranslation()

  const openMap = () => {
    const lat = data.event?.location?.latitude
    const lng = data.event?.location?.longitude

    const userAgent = navigator.userAgent.toLowerCase()
    let url

    if (/iphone|ipad|ipod/.test(userAgent)) {
      url = `http://maps.apple.com/?ll=${lat},${lng}`
    } else {
      url = `https://www.google.com/maps?q=${lat},${lng}`
    }

    window.location.href = url
  }

  return (
    <div className={css.wrapper}>
      <div data-testid={DataTestId.bag.ticketDetailsTitle} className={css.detailsTitle}>{t('goodsAndServices:details_title')}</div>

      <div data-testid={DataTestId.bag.ticketDetailsVoices} className={css.voices}>
        {data.locationName && (
          <>
            <div className={css.voice}>{`${t('goodsAndServices:details_location_name')}: `}</div>
            <div className={css.desc}>{`${data.locationName}`}</div>
          </>
        )}

        {data.event?.location?.address && (
          <>
            <div className={css.voice}>{`${t('goodsAndServices:details_location_address')}: `}</div>
            <div onClick={openMap} className={classNames(css.desc, css.address)}>
              {data.event?.location?.address}
            </div>
          </>
        )}

        {data.status && (
          <>
            <div className={css.voice}>{`${t('goodsAndServices:details_status')}: `}</div>
            <div className={css.desc}>{`${t(`goodsAndServices:status_${data.status}`)}`}</div>
          </>
        )}

        {data.emissionDate_tz && (
          <>
            <div className={css.voice}>{`${t('goodsAndServices:details_purchase_data')}:`}</div>
            <div
              className={css.desc}
            >{`${Dates.format(new Date(data.emissionDate_tz), t('goodsAndServices:status_checked_datetime'))}`}</div>
          </>
        )}

        {data.validFrom_tz && (
          <>
            <div className={css.voice}>{`${t('goodsAndServices:details_usable_from')}: `}</div>
            <div
              className={css.desc}
            >{`${Dates.format(new Date(data.validFrom_tz), t('goodsAndServices:details_usable_from_datetime'))}`}</div>
          </>
        )}

        {data.validTo_tz && (
          <>
            <div className={css.voice}>{`${t('goodsAndServices:details_usable_until')}: `}</div>
            <div
              className={css.desc}
            >{`${Dates.format(new Date(data.validTo_tz), t('goodsAndServices:details_usable_from_datetime'))}`}</div>
          </>
        )}

        {data.price && (
          <>
            <div className={css.voice}>{`${t('goodsAndServices:details_price')}: `}</div>
            <div className={css.desc}>{`${data.price.formatted}`}</div>
          </>
        )}
      </div>

      {data.receiptsUri && (
        <div className={css.showReceipt}>
          <ButtonWhiteBlack
            className={css.receiptButton}
            onClick={() => {
              window.open(data.receiptsUri, '_blank')
            }}
          >
            <h5>{t('wallet:show_receipt')}</h5>
          </ButtonWhiteBlack>
        </div>
      )}
    </div>
  )
}

export default Details
